// ==========================
// Version 2 — pages/AdminLayout.js (shell + sidebar + Moderation link)
// ==========================
import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';

const NAVY = '#0A1A33';
const IVORY = '#FDFCF9';
const GOLD = '#C9A44C';
const WARM_GRAY = '#888888';

export default function AdminLayout() {
  const { pathname } = useLocation();

  return (
    <div style={{ minHeight: 'calc(100dvh - 64px)', background: NAVY, color: IVORY }}>
      <div style={wrap}>
        <aside style={side}>
          <div style={sideHeader}>Admin</div>
          <nav style={{ display: 'grid', gap: 8 }}>
            <SideLink to="/admin" label="Dashboard" active={pathname === '/admin'} />
            <SideLink to="/admin/users" label="Users" active={pathname.startsWith('/admin/users')} />
            <SideLink to="/admin/memories" label="Memories" active={pathname.startsWith('/admin/memories')} />
            <SideLink to="/admin/activity" label="Activity" active={pathname.startsWith('/admin/activity')} />
            <SideLink to="/admin/flags" label="Flags" active={pathname.startsWith('/admin/flags')} />
            <SideLink to="/admin/moderation" label="Moderation" active={pathname.startsWith('/admin/moderation')} />
          </nav>
        </aside>

        <section style={main}>
          <Outlet />
        </section>
      </div>
    </div>
  );
}

function SideLink({ to, label, active }) {
  return (
    <NavLink to={to} style={{ ...sideLink, ...(active ? sideLinkActive : null) }}>
      {label}
    </NavLink>
  );
}

const wrap = {
  display: 'grid',
  gridTemplateColumns: '260px 1fr',
  gap: 16,
  maxWidth: 1200,
  margin: '0 auto',
  padding: '16px',
};
const side = {
  background: 'rgba(253,252,249,0.04)',
  border: '1px solid rgba(201,164,76,0.25)',
  borderRadius: 14,
  padding: 12,
};
const sideHeader = {
  fontFamily: 'serif',
  fontSize: 22,
  marginBottom: 10,
};
const sideLink = {
  display: 'block',
  textDecoration: 'none',
  color: IVORY,
  padding: '10px 12px',
  border: '1px solid transparent',
  borderRadius: 12,
  fontWeight: 700,
  background: 'transparent',
};
const sideLinkActive = {
  background: GOLD,
  color: NAVY,
  borderColor: GOLD,
};
const main = {
  background: 'rgba(253,252,249,0.04)',
  border: '1px solid rgba(201,164,76,0.25)',
  borderRadius: 14,
  padding: 16,
};
// ==========================
// End Version 2 — pages/AdminLayout.js
// ==========================
